import { render, staticRenderFns } from "./AlbumArt.vue?vue&type=template&id=5bb16103&"
import script from "./AlbumArt.vue?vue&type=script&lang=js&"
export * from "./AlbumArt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports